export const EXECUTIVE_OFFICES = [
  {
    id: 'co_ibague',
    name: 'CO Ibague',
    lat: 4.437347,
    lng: -75.217362
  },
  {
    id: 'co_bogota',
    name: 'CO Chia',
    lat: 4.859444,
    lng: -74.05725
  }
] as const
